/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'macbook': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M116.304 96.826V52.261c0-2.085-1.136-3.261-3.26-3.261H36.956c-2.127 0-3.261 1.095-3.261 3.26v44.566H25c.115.2.277.703.46.703 0 0 4.502 2.713 10.085 3.09 5.579.379 13.356.58 13.368.555.004-.006 26.087 0 26.087 0h23.913s10.083-.183 15.663-.554c5.584-.372 10.02-3.091 10.02-3.091.184 0 .29-.503.404-.703h-8.696zm-78.26-43.478h73.913v43.478H38.043V53.348z"/>'
  }
})
